import Helper from '../riHelper';
import Promise from 'bluebird';
import { every } from '@/central';
var TaxonomyHelper = (function () {
    function TaxonomyHelper() {
    }
    TaxonomyHelper.getWssIdByTermId = function (termId) {
        return new Promise(function (resolve, reject) {
            Helper.context()
                .then(function (ctx) {
                var list = ctx
                    .get_site()
                    .get_rootWeb()
                    .getList(_spPageContextInfo.siteAbsoluteUrl + '/lists/TaxonomyHiddenList');
                var q = new SP.CamlQuery();
                q.set_viewXml("<View><Query><Where><Eq><FieldRef Name='IdForTerm'/><Value Type='Text'>" + termId + "</Value></Eq></Where></Query><RowLimit>1</RowLimit></View>");
                var items = list.getItems(q);
                ctx.load(items);
                return Helper.clientContextExecute(ctx).then(function () {
                    if (items.get_areItemsAvailable() && items.get_count() > 0) {
                        var item = items.getItemAtIndex(0);
                        resolve(item.get_id());
                    }
                    else {
                        resolve(0);
                    }
                });
            })
                .catch(reject);
        });
    };
    TaxonomyHelper.getChildrenWssIdsByTermItem = function (term) {
        return new Promise(function (resolve, reject) {
            Helper.context()
                .then(function (ctx) {
                var list = ctx
                    .get_site()
                    .get_rootWeb()
                    .getList(_spPageContextInfo.siteAbsoluteUrl + '/lists/TaxonomyHiddenList');
                var q = new SP.CamlQuery();
                q.set_viewXml("<View><Query><Where>" +
                    "<And>" +
                    "<Or>" +
                    ("<BeginsWith><FieldRef Name='Path'/><Value Type='Text'>" + term.path.replace(/;/g, ':') + "</Value></BeginsWith>") +
                    ("<BeginsWith><FieldRef Name='Path1031'/><Value Type='Text'>" + term.path.replace(/;/g, ':') + "</Value></BeginsWith>") +
                    "</Or>" +
                    ("<Eq><FieldRef Name='IdForTermSet'/><Value Type='Text'>" + term.termSetId + "</Value></Eq>") +
                    "</And>" +
                    "</Where></Query></View>");
                console.log('getChildrenWssIdsByTermItem', q.get_viewXml());
                var items = list.getItems(q);
                var ids = [];
                ctx.load(items);
                return Helper.clientContextExecute(ctx).then(function () {
                    if (items.get_areItemsAvailable() && items.get_count() > 0) {
                        every(items, function (item) {
                            ids.push(item.get_id());
                        });
                    }
                    resolve(ids);
                });
            })
                .catch(reject);
        });
    };
    TaxonomyHelper.getTermFieldValues = function (fieldValue) {
        var result = [];
        if (fieldValue) {
            if (typeof fieldValue.populateFromLabelGuidPairs === 'function') {
                var values = fieldValue;
                if (values.get_areItemsAvailable()) {
                    every(values, function (value) {
                        result.push(value);
                    });
                }
            }
            else if (typeof fieldValue.get_termGuid === 'function') {
                result.push(fieldValue);
            }
        }
        return result;
    };
    TaxonomyHelper.tryGetLabelWithHyphen = function (term) {
        if (!term)
            return '';
        var label = term.get_name();
        var properties = term.get_customProperties();
        var hyphen = properties['Silbentrennung'];
        if (hyphen) {
            label = hyphen.replace(/-/g, '&shy;');
        }
        else {
            label = label.replace(/＆/g, '&amp;');
        }
        return label;
    };
    return TaxonomyHelper;
}());
export { TaxonomyHelper };
